module.exports = __webpack_public_path__ + "img/icons-sprite.63b3dc23.svg";